import { useSubjectsQuery } from 'api/generated';
import { getBaseOptions } from 'api/wrappers';
export const useSubjectsQueryApi = (variables, options) => {
    const { data, ...rest } = useSubjectsQuery(getBaseOptions(variables ?? {}, {
        ...options,
        fetchPolicy: 'cache-first',
    }));
    const subjects = data?.subjects ?? [];
    return { ...rest, data: subjects };
};
